import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions, createRouteNodeSelector } from 'redux-router5';
import {
  Grid,
  Menu,
  Header,
  Container,
  Loader,
  Segment,
  Message,
  Divider,
} from 'semantic-ui-react';

import SymbolImg from 'assets/img/symbol.png';
import IntuitLogoImg from 'assets/img/q-b-intuit-logo-horiz-r-g-b.png';

import Setup from '../Setup';
import Status from '../Status';
import NotFound from '../NotFound';
import NavItem from '../Common/NavItem';
import StatusTitle from './components/StatusTitle';
import RegionPanel from './components/RegionPanel';

import './qbTabs.scss';

class QbTabs extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.router = context.router;
  }

  render() {
    const {
      call,
      errorMessage,
      navigateTo,
      route,
      statusDescription,
      statusLoading,
      tick,
      syncHistoryLoading,
      syncHistory,
      syncLogs,
      syncError,
    } = this.props;
    const linkOptions = { reload: true };

    let routeName = '';
    let content = <NotFound key="notFound" />;

    if (route && route.name) {
      const routeArr = route.name.split('.');

      if (routeArr.length > 1) {
        routeName = routeArr[1].toLowerCase();

        if (route.meta.id === 1 && statusDescription === 'Not Connected' && routeName !== 'setup') {
          navigateTo('qb.setup', linkOptions);

          return null;
        }

        switch (routeName) {
          case 'status':
            content = (
              <Status
                key="status"
                call={ call }
                syncHistory = { syncHistory }
                syncLogs={ syncLogs }
                syncError = { syncError }
                tick={ tick }
              />);
            break;

          case 'setup':
            content = <Setup key="setup" />;
            break;

          default:
            content = <NotFound key="notFound" />;
            break;
        }
      }
    }

    return (
      <div className="qb--tabs">
        { syncHistory &&
          <RegionPanel region={ syncHistory.region } version={ syncHistory.version } /> }

        <Grid key="header">
          <Grid.Column width={ 16 }>
            <Container className="header">
              <div className="logos">
                <img alt="" className="img--mhd" src={ SymbolImg } />
                <span>+</span>
                <img alt="" className="img--qb" src={ IntuitLogoImg } />
              </div>

              <Header as="h1">QuickBooks Integration Center</Header>

              { !errorMessage && syncHistoryLoading && (
                <div className="status--loading">
                  <Loader active size="small" />
                </div>) }

              { !errorMessage && !syncHistoryLoading && <StatusTitle status={ statusDescription } /> }
            </Container>

            <Divider />
          </Grid.Column>
        </Grid>,

        <Container key="container">
          <Grid>
            <Grid.Column width={ 16 }>
              { errorMessage && <Message negative>{ errorMessage }</Message> }

              { !errorMessage && statusLoading && <Loader active size="large" style={ { marginTop: 50 } } /> }

              { !errorMessage && !statusLoading && (
                <div>
                  <Menu attached="top" tabular>
                    <NavItem
                      className={ `item ${routeName === 'status' ? 'active' : ''}` }
                      options={ linkOptions }
                      routeName="qb.status"
                    >Log
                    </NavItem>

                    <NavItem
                      className={ `item ${routeName === 'setup' ? 'active' : ''}` }
                      options={ linkOptions }
                      routeName="qb.setup"
                    >Set-Up
                    </NavItem>
                  </Menu>

                  <Segment attached="bottom" style={ { paddingRight: 30, paddingLeft: 30 } }>
                    { content }
                  </Segment>
                </div>
              ) }
            </Grid.Column>
          </Grid>
        </Container>
      </div>
    );
  }
}

QbTabs.defaultProps = {
  errorMessage: null,
  route: { name: '' },
  syncHistory: null,
  syncLogs: null,
};

QbTabs.propTypes = {
  errorMessage: PropTypes.string,
  route: PropTypes.shape({ name: PropTypes.string.isRequired }),
  syncHistory: PropTypes.object,
  syncLogs: PropTypes.object,
  statusDescription: PropTypes.string.isRequired,
  statusLoading: PropTypes.bool.isRequired,
  syncError: PropTypes.string,

  // functions
  call: PropTypes.func.isRequired,
  tick: PropTypes.func.isRequired,
  navigateTo: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  ...createRouteNodeSelector('')(state),
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    navigateTo: actions.navigateTo,
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(QbTabs);



// WEBPACK FOOTER //
// ./src/components/QbTabs/index.js